import React, { useEffect, useMemo, useState } from "react";
import { Box, Paper, Typography, Divider } from "@material-ui/core";
import BranchSelect from "../../Components/BranchSelect";
import DateRangeBar from "../../Components/DateRangeBar";
import ExportButtons from "../../Components/ExportButtons";
import DataTable from "../../Components/DataTable";
import { Api } from "../../api/client";
import { money, num } from "../../utils/format";
import { todayISO, daysAgoISO } from "./_date";

export default function HistorialCliente(){
  const [branches, setBranches] = useState([]);
  const [branchId, setBranchId] = useState("");
  const [range, setRange] = useState({ from: daysAgoISO(30), to: todayISO() });

  const [rows, setRows] = useState([]);

  const params = useMemo(()=>({
    from: range.from, to: range.to, branch: branchId
  }), [range, branchId]);

  useEffect(()=>{
    Api.branches().then(res => setBranches(res.data))
      .catch(()=> setBranches([{id:"", nombre:"Todas"}]));
  }, []);

  useEffect(()=>{
    async function load(){
      try{
        const r = await Api.ordersByCustomer(params);
        const list = Array.isArray(r) ? r : (r?.data || []);
        setRows(list);
      }catch(e){
        console.error(e);
        setRows([]);
      }
    }
    load();
  }, [params]);

  const columns = [
    { key:"cliente", label:"Cliente" },
    { key:"pedidos", label:"Pedidos", render:r=>num(r.pedidos) },
    { key:"frecuenciaDias", label:"Frecuencia (días)" },
    { key:"preferencia", label:"Preferencia" },
    { key:"ticketProm", label:"Ticket prom", render:r=>money(r.ticketProm) },
  ];

  return (
    <Paper style={{padding:18, borderRadius:14}}>
      <Typography variant="h6" style={{fontWeight:900}}>Historial por cliente</Typography>
      <Divider style={{margin:"12px 0"}}/>

      <Box display="flex" gridGap={12} flexWrap="wrap">
        <BranchSelect value={branchId} options={branches} onChange={setBranchId}/>
        <DateRangeBar from={range.from} to={range.to} onChange={setRange}/>
        <ExportButtons filename={`historial_clientes_${params.from}_a_${params.to}.csv`} rows={rows}/>
      </Box>

      <Box mt={2}>
        <DataTable columns={columns} rows={rows}/>
      </Box>
    </Paper>
  );
}